import { IProcedure } from 'common/schema/Procedure';
import { yup } from 'common/validation/initYup';
import { createProcedureValuesValidator } from 'common/schema/request/createProcedureValuesValidator';
import { ICaptchaCryptedTokens } from 'server/captcha/CaptchaService';

/**
 * DTO per la ricerca delle richieste
 */
export const requestsQueryValidator = yup
  .object({
    /** Se attivo, ritorna solo le fatture inviate */
    filterSent: yup.boolean().notRequired(),
    page: yup.number().required().default(1),
    pageSize: yup.number().required().default(10)
  })
  .required()
  .noUnknown();

export type IRequestsQueryDto = yup.InferType<typeof requestsQueryValidator>;

/**
 * DTO per l'invio di una richiesta (istanza)
 */
export const createRequestValidator = (procedure: IProcedure) => {
  return yup
    .object({
      id: yup.number().notRequired(),
      values: createProcedureValuesValidator(procedure),
      /** Specifica se la richiesta deve essere inviata al momento del salvataggio */
      sendRightNow: yup.boolean().default(false),
      // bindToken: yup.string()
      captchaTokens: yup.object<ICaptchaCryptedTokens>().required().default({})
    })
    .noUnknown()
    .required();
};

export type ICreateRequestDto = yup.InferType<
  ReturnType<typeof createRequestValidator>
>;
